import React, { useState } from 'react';
import { 
  Printer, Key, Save, Trash2, CheckCircle2, 
  Eye, EyeOff, UserPlus, QrCode, HardDrive, Edit3,
  Monitor, Globe, Settings2, X
} from 'lucide-react';

const AjustesSistema = () => {
  const [seccion, setSeccion] = useState('hardware'); 
  const [mostrarPass, setMostrarPass] = useState(false);
  const [modoEdicionAcceso, setModoEdicionAcceso] = useState(false);

  // --- 1. HARDWARE (CONFIGURACIÓN ZEBRA) ---
  const [impresoras, setImpresoras] = useState([
    { id: 1, nombre: 'ZEBRA ZD220', tipo: 'Driver Sistema', papel: '80mm', activa: true }
  ]);

  const [disenoTicket, setDisenoTicket] = useState({
    mostrarLogo: true,
    mostrarSalon: true,
    encabezado: 'CASA DE FE - IGLEKIDS',
    piePagina: 'Seguridad y Gracia',
    anchoPapel: '80mm'
  });

  // --- 2. GESTIÓN DE USUARIOS DE RECEPCIÓN ---
  const [usuariosRecepcion, setUsuariosRecepcion] = useState([
    { id: 1, usuario: 'RECEPCION_01', nombre: 'Ana Karen', password: '123' },
    { id: 2, usuario: 'RECEPCION_02', nombre: 'Roberto D.', password: '456' }
  ]);
  const [formUsuario, setFormUsuario] = useState({ id: null, usuario: '', nombre: '', password: '' });

  // --- 3. PRIVACIDAD & TEXTOS DINÁMICOS ---
  const [mensajes] = useState([
    { id: 1, titulo: 'Campaña General', texto: '¡Bienvenidos a Casa de Fe!', esDefault: true }
  ]);

  // --- LÓGICA DE USUARIOS ---
  const prepararEdicionUsuario = (u) => {
    setFormUsuario(u);
    setModoEdicionAcceso(true);
  };

  const guardarUsuario = () => {
    if(!formUsuario.usuario || !formUsuario.password) return alert("Usuario y contraseña son obligatorios");
    
    if(formUsuario.id) {
      setUsuariosRecepcion(usuariosRecepcion.map(u => u.id === formUsuario.id ? formUsuario : u));
    } else {
      setUsuariosRecepcion([...usuariosRecepcion, { ...formUsuario, id: Date.now() }]);
    }
    cancelarEdicionUsuario();
  };

  const cancelarEdicionUsuario = () => {
    setModoEdicionAcceso(false);
    setFormUsuario({ id: null, usuario: '', nombre: '', password: '' });
  };

  return (
    <div className="w-full max-w-[1400px] mx-auto space-y-8 animate-in fade-in duration-500 pb-24 px-4 text-left font-sans">
      
      {/* CSS PARA CONTROL DE IMPRESIÓN (ESTRICTO ZEBRA) */}
      <style dangerouslySetInnerHTML={{ __html: `
        @media print {
          body * { visibility: hidden; }
          #ticket-area, #ticket-area * { visibility: visible; }
          #ticket-area { position: fixed; left: 0; top: 0; width: ${disenoTicket.anchoPapel}; margin: 0; padding: 10px; border: none; }
          @page { margin: 0; size: auto; }
        }
      `}} />

      {/* HEADER DE COMANDO */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 border-b-4 border-slate-100 pb-8">
        <div className="space-y-1 text-left">
          <div className="inline-flex items-center gap-2 bg-[#0A2440] text-white px-4 py-2 rounded-full shadow-lg">
            <HardDrive size={16} className="text-emerald-400" />
            <span className="text-[10px] font-black uppercase tracking-widest text-slate-200 italic">Panel de Ajustes Maestros</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-slate-900 italic tracking-tighter uppercase leading-none">Sistema</h2>
        </div>
        <button onClick={() => alert("✅ Configuración sincronizada con Firebase.")} className="bg-emerald-500 text-white px-10 py-5 rounded-[2rem] font-black text-sm uppercase tracking-widest shadow-xl flex items-center justify-center gap-3 hover:bg-emerald-600 transition-all active:scale-95 border-b-4 border-emerald-700">
          <Save size={20} /> Guardar Cambios
        </button>
      </div>

      {/* NAVEGACIÓN DE SECCIONES */}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        {[
          { id: 'hardware', label: 'Impresoras', icon: Printer, color: 'text-blue-600' },
          { id: 'ticket', label: 'Diseño Ticket', icon: QrCode, color: 'text-emerald-600' },
          { id: 'recepcionistas', label: 'Terminales', icon: Key, color: 'text-purple-600' },
          { id: 'privacidad', label: 'Seguridad', icon: Monitor, color: 'text-amber-600' },
          { id: 'textos', label: 'Temporadas', icon: Globe, color: 'text-rose-600' }
        ].map(tab => (
          <button 
            key={tab.id} 
            onClick={() => setSeccion(tab.id)} 
            className={`p-6 rounded-[3rem] border-4 transition-all flex flex-col items-center gap-2 ${
              seccion === tab.id 
                ? 'bg-white border-slate-900 shadow-2xl scale-105' 
                : 'bg-white border-transparent opacity-40 hover:opacity-100 hover:border-slate-100'
            }`}
          >
            <tab.icon size={28} className={seccion === tab.id ? tab.color : 'text-slate-300'} />
            <span className="text-[10px] font-black uppercase tracking-widest italic">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-12 gap-8 items-start">
        <div className="xl:col-span-8 space-y-6">
          
          {/* SECCIÓN USUARIOS */}
          {seccion === 'recepcionistas' && (
            <div className="bg-white p-8 md:p-12 rounded-[4rem] border-2 border-slate-50 shadow-sm space-y-8 animate-in slide-in-from-right-4">
              <div className="flex justify-between items-center text-left">
                <div className="space-y-1">
                  <h3 className="text-2xl font-black italic uppercase text-slate-800">Terminales de Recepción</h3>
                  <p className="text-[10px] font-bold text-slate-400 uppercase italic tracking-widest">Cuentas activas para el staff de entrada</p>
                </div>
                {!modoEdicionAcceso && (
                  <button onClick={() => setModoEdicionAcceso(true)} className="px-6 py-3 bg-slate-900 text-white rounded-2xl font-black uppercase text-[10px] flex items-center gap-2 hover:bg-purple-600 transition-all shadow-md">
                    <UserPlus size={16}/> Nueva Terminal
                  </button>
                )}
              </div>

              {modoEdicionAcceso ? (
                <div className="bg-slate-50 p-8 rounded-[3.5rem] border-4 border-dashed border-purple-200 space-y-6 animate-in zoom-in-95 text-left">
                  <h4 className="text-sm font-black uppercase text-purple-600 italic leading-none">Credenciales de Operador</h4>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                       <label className="text-[10px] font-black text-slate-400 uppercase ml-4">Nombre Staff</label>
                       <input value={formUsuario.nombre} onChange={(e) => setFormUsuario({...formUsuario, nombre: e.target.value})} placeholder="Ej. Ana Karen" className="w-full p-5 rounded-2xl border-none font-bold outline-none shadow-inner bg-white"/>
                    </div>
                    <div className="space-y-2">
                       <label className="text-[10px] font-black text-slate-400 uppercase ml-4">Usuario ID</label>
                       <input value={formUsuario.usuario} onChange={(e) => setFormUsuario({...formUsuario, usuario: e.target.value.toUpperCase()})} placeholder="STAFF_01" className="w-full p-5 rounded-2xl border-none font-bold outline-none uppercase shadow-inner bg-white"/>
                    </div>
                    <div className="space-y-2 md:col-span-2">
                       <label className="text-[10px] font-black text-slate-400 uppercase ml-4">Contraseña</label>
                       <div className="relative">
                          <input type={mostrarPass ? "text" : "password"} value={formUsuario.password} onChange={(e) => setFormUsuario({...formUsuario, password: e.target.value})} placeholder="Pin de acceso" className="w-full p-5 rounded-2xl border-none font-bold outline-none shadow-inner bg-white"/>
                          <button onClick={() => setMostrarPass(!mostrarPass)} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-300 hover:text-purple-600">
                            {mostrarPass ? <EyeOff size={20}/> : <Eye size={20}/>}
                          </button>
                       </div>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <button onClick={cancelarEdicionUsuario} className="flex-1 py-5 font-black uppercase text-[10px] text-slate-400 tracking-widest italic">Descartar</button>
                    <button onClick={guardarUsuario} className="flex-[2] py-5 bg-indigo-600 text-white rounded-3xl font-black uppercase text-[10px] tracking-widest shadow-xl active:scale-95 transition-all">
                      {formUsuario.id ? 'Guardar Cambios' : 'Confirmar Registro'}
                    </button>
                  </div>
                </div>
              ) : (
                <div className="grid md:grid-cols-2 gap-4">
                  {usuariosRecepcion.map(u => (
                    <div key={u.id} className="p-6 bg-slate-50 rounded-[2.5rem] flex justify-between items-center border-2 border-transparent hover:border-purple-200 transition-all group">
                      <div className="flex items-center gap-4 text-left">
                        <div className="w-14 h-14 bg-white group-hover:bg-purple-600 group-hover:text-white rounded-2xl flex items-center justify-center text-purple-600 shadow-sm transition-all">
                          <Key size={24}/>
                        </div>
                        <div>
                          <p className="font-black text-slate-800 leading-none uppercase italic">{u.nombre}</p>
                          <p className="text-[10px] font-black text-purple-400 uppercase mt-1 tracking-widest italic">{u.usuario}</p>
                        </div>
                      </div>
                      <div className="flex gap-2">
                        <button onClick={() => prepararEdicionUsuario(u)} className="p-3 bg-white rounded-xl text-slate-300 hover:text-indigo-600 hover:shadow-md transition-all"><Edit3 size={18}/></button>
                        <button onClick={() => setUsuariosRecepcion(usuariosRecepcion.filter(user => user.id !== u.id))} className="p-3 bg-white rounded-xl text-slate-300 hover:text-rose-500 hover:shadow-md transition-all"><Trash2 size={18}/></button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* HARDWARE SECTION */}
          {seccion === 'hardware' && (
            <div className="bg-white p-8 md:p-12 rounded-[4rem] border-2 border-slate-50 shadow-sm space-y-8 animate-in slide-in-from-left-4 text-left">
              <h3 className="text-2xl font-black italic uppercase text-slate-800">Periféricos de Seguridad</h3>
              <div className="grid gap-4">
                {impresoras.map(imp => (
                  <div key={imp.id} className={`p-8 rounded-[3.5rem] border-4 flex justify-between items-center transition-all ${imp.activa ? 'border-indigo-600 bg-indigo-50/20' : 'bg-slate-50 border-slate-100 opacity-60'}`}>
                    <div className="flex items-center gap-6">
                      <div className={`p-4 rounded-3xl ${imp.activa ? 'bg-[#0A2440] text-white' : 'bg-slate-200 text-slate-400'}`}>
                        <Printer size={32} />
                      </div>
                      <div>
                        <p className="font-black text-xl text-slate-800 uppercase italic tracking-tighter">{imp.nombre}</p>
                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest italic">{imp.tipo} • Papel {imp.papel}</p>
                      </div>
                    </div>
                    <button onClick={() => setImpresoras(impresoras.map(i => ({...i, activa: i.id === imp.id})))} className={`px-8 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest ${imp.activa ? 'bg-emerald-500 text-white shadow-lg' : 'bg-white text-slate-400 border border-slate-200'}`}>{imp.activa ? 'Sincronizada' : 'Vincular'}</button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* TICKET SECTION */}
          {seccion === 'ticket' && (
            <div className="bg-white p-8 md:p-12 rounded-[4rem] border-2 border-slate-50 shadow-sm space-y-10 animate-in slide-in-from-bottom-4">
              <div className="flex justify-between items-center text-left">
                <div className="space-y-1">
                  <h3 className="text-2xl font-black italic uppercase text-slate-800 leading-none">Diseño de Comprobante</h3>
                  <p className="text-[10px] font-bold text-slate-400 uppercase italic tracking-widest">Lo que el padre debe mostrar en el salón</p>
                </div>
                <button onClick={() => window.print()} className="px-8 py-4 bg-[#0A2440] text-white rounded-3xl font-black uppercase text-[10px] tracking-widest flex items-center gap-2 shadow-xl hover:bg-indigo-600 active:scale-95 transition-all">
                  <Printer size={18}/> Imprimir Prueba
                </button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                <div className="space-y-6 text-left">
                   <div className="space-y-2">
                      <label className="text-[10px] font-black text-slate-400 uppercase ml-4 italic">Nombre del Ministerio</label>
                      <input value={disenoTicket.encabezado} onChange={(e) => setDisenoTicket({...disenoTicket, encabezado: e.target.value.toUpperCase()})} className="w-full p-5 bg-slate-50 rounded-2xl font-black text-slate-700 border-2 border-transparent focus:border-indigo-500 outline-none uppercase shadow-inner" />
                   </div>
                   <div className="space-y-2">
                      <label className="text-[10px] font-black text-slate-400 uppercase ml-4 italic">Mensaje de Pie de Página</label>
                      <input value={disenoTicket.piePagina} onChange={(e) => setDisenoTicket({...disenoTicket, piePagina: e.target.value})} className="w-full p-5 bg-slate-50 rounded-2xl font-bold text-slate-700 border-2 border-transparent focus:border-indigo-500 outline-none shadow-inner" />
                   </div>
                </div>
                {/* PREVIEW DEL TICKET */}
                <div id="ticket-area" className="bg-white p-8 shadow-2xl border-2 border-slate-50 text-black font-mono text-center flex flex-col items-center mx-auto rounded-lg" style={{ width: disenoTicket.anchoPapel }}>
                  <p className="font-black border-b-2 border-black pb-3 mb-3 uppercase w-full text-sm italic">{disenoTicket.encabezado}</p>
                  <p className="text-[10px] font-bold opacity-60 italic">COMPROBANTE DE RETIRO</p>
                  <p className="text-3xl font-black mt-4 uppercase leading-none italic tracking-tighter">MATEO LUNA</p>
                  <p className="text-[11px] font-black mt-1 uppercase italic tracking-widest bg-black text-white px-4 py-1.5 rounded mt-3">PÁRVULOS B</p>
                  <div className="py-8"><QrCode size={160} strokeWidth={1} /></div>
                  <div className="space-y-1">
                    <p className="text-[8px] font-black uppercase">SERVICIO: {new Date().toLocaleDateString()}</p>
                    <p className="text-[12px] font-black uppercase italic tracking-widest border-t border-black pt-2">#OK-4420</p>
                  </div>
                  <p className="italic text-[9px] mt-6 font-bold border-t border-dashed border-slate-300 pt-4 w-full opacity-60">"{disenoTicket.piePagina}"</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* MONITOR LATERAL */}
        <div className="xl:col-span-4 space-y-6 text-left">
          <div className="bg-slate-900 p-10 rounded-[4rem] text-white shadow-2xl space-y-10 relative overflow-hidden border-b-8 border-amber-500">
            <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500/10 rounded-bl-full" />
            <h4 className="text-[10px] font-black uppercase tracking-[0.4em] text-indigo-400 italic">Satus del Motor</h4>
            <div className="space-y-8 relative z-10">
              <div className="flex items-center gap-5">
                <div className="w-12 h-12 bg-emerald-500/20 text-emerald-400 rounded-2xl flex items-center justify-center border border-emerald-500/30">
                  <Printer size={24}/>
                </div>
                <div>
                  <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest">Hardware Zebra</p>
                  <p className="text-sm font-black uppercase italic text-white leading-none">{impresoras.find(i => i.activa)?.nombre}</p>
                </div>
              </div>
              
              <div className="flex items-center gap-5">
                <div className="w-12 h-12 bg-purple-500/20 text-purple-400 rounded-2xl flex items-center justify-center border border-purple-500/30">
                  <Key size={24}/>
                </div>
                <div>
                  <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest">Terminales Staff</p>
                  <p className="text-sm font-black uppercase italic text-white leading-none">{usuariosRecepcion.length} Estaciones</p>
                </div>
              </div>

              <div className="bg-white/5 p-6 rounded-3xl border border-white/10 space-y-4">
                <p className="text-[9px] font-black text-amber-500 uppercase tracking-widest text-center italic">Campaña de Temporada</p>
                <p className="text-xs font-bold italic text-slate-300 leading-relaxed text-center">
                  "{mensajes.find(m => m.esDefault)?.texto}"
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AjustesSistema;